module.exports = __webpack_public_path__ + "media/landing-page/como-funciona-3-1372bd4b.svg";